import { DateTimeFactory } from './../model/date-factory';
import { ActivatedRoute } from '@angular/router';
import { MapPosition } from './../shared/map/map-position';
import { Component, OnInit } from '@angular/core';
import { icon, latLng, marker, tileLayer, TileLayer } from 'leaflet';
import { TruckRouteService } from '../shared/map/truck-route.service';
declare let L;

@Component({
  selector: 'osca-map-truck',
  templateUrl: './map.component.html',
  styles: []
})

export class MapTruckComponent implements OnInit {
  markers: TileLayer[] = [];
  constructor( private trs: TruckRouteService, private activatedRoute: ActivatedRoute ) { }

  ngOnInit() {

    document.getElementById('weathermap').innerHTML = '<div id="map" style="width: 100%; height: 100%;"></div>';

    const map = new L.map('map', {
        zoom: 5,
        center: [18.8, 112.75],
        zoomControl: true
    });

    tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      detectRetina: true,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    this.activatedRoute.queryParams.subscribe(p => {
       this.trs.getRouteByTruck(p['departure'], p['arrival'],
              DateTimeFactory.formatDateTime(p['etd'], 0, 'DD.MM.YYYY'))
          .subscribe(posList => {
            this.create(map, posList);
          });
    });
  }

  create(map: any, posList: MapPosition[]) {
    if (posList !== null && posList.length > 0) {
      const route = [];
      for (let i = 0; i < posList.length; i++) {
        route.push( latLng(posList[i].lat, posList[i].lon) );
        const m = marker(latLng(posList[i].lat, posList[i].lon), {
          icon: icon({
            iconSize: [ 16, 16 ],
            iconAnchor: [ 7, 7 ],
            iconUrl: 'assets/images/location.svg'
          })
        });
        m.bindTooltip(posList[i].title + '<br>' + posList[i].timestamp);
        m.addTo(map);
      }

      if (posList.length > 1) {
        L.polyline(route).addTo(map);
      }

      const pos = posList[posList.length - 1];
      const lastMarker = this.createMarker(pos);
      lastMarker.bindTooltip(pos.title + '<br>' + pos.timestamp);
      map.setView(lastMarker.getLatLng(), map.getZoom());
      lastMarker.addTo(map);
    }


  }

  createMarker(pos: MapPosition): any {
    return marker(latLng( pos.lat, pos.lon ), {
      icon: icon({
        iconSize: [ 12, 20 ],
        iconAnchor: [ 6, 20 ],
        iconUrl: 'leaflet/marker-icon.png'})
    });
  }

}
